import { render, staticRenderFns } from "./UnitSwitcher.vue?vue&type=template&id=36c38b7b&scoped=true&"
import script from "./UnitSwitcher.vue?vue&type=script&lang=js&"
export * from "./UnitSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./UnitSwitcher.vue?vue&type=style&index=0&id=36c38b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c38b7b",
  null
  
)

export default component.exports